/**
 * メッセージのレベル（種別）定義
 */
export class MsgLevel {

    /**
     * 情報
     */
    public static INFO: string = 'info';

    /**
     * 警告
     */
    public static WARNING: string = 'warning';

    /**
     * エラー（危険）
     */
    public static ERROR: string = 'danger';

    /**
     * 成功
     */
    public static SUCCESS: string = 'success';
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/framework/controller/MsgLevel.ts
 **/